import { locales } from "../lib";

export const getLocalesAsParams = () => locales.map((locale) => ({ locale }));
